import styled from 'styled-components'
import { rem } from 'polished'
import { aiGlowRotatingBorderLayer } from 'lib/aiGlow/aiGlow'

/**
 * A wrapper component that applies a rotating AI glow border effect.
 * Wrap any element with this component to give it an animated gradient border.
 *
 * The child element will automatically get:
 * - position: relative and z-index: 1 to appear above the gradient
 * - white background and border-radius to match the glow
 */
const AIGlowBorder = styled.div`
  ${aiGlowRotatingBorderLayer}

  position: relative;
  width: 100%;
  border-radius: ${rem(4)};
  padding: ${rem(2)};
  overflow: hidden;

  > * {
    position: relative;
    z-index: 1;
    background: ${props => props.theme.palette.neutral.surface.normalBackground};
    border-radius: ${rem(2)};
  }
`

export default AIGlowBorder
